/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Facts_Platforms_ValueInputs */

const en_vc_facts_platforms_value = /** @type {(inputs: Vc_Facts_Platforms_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mac, Windows, Linux, FreeBSD, Web`)
};

const zh_vc_facts_platforms_value = /** @type {(inputs: Vc_Facts_Platforms_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mac、Windows、Linux、FreeBSD、网页`)
};

/**
* | output |
* | --- |
* | "Mac, Windows, Linux, FreeBSD, Web" |
*
* @param {Vc_Facts_Platforms_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_facts_platforms_value = /** @type {((inputs?: Vc_Facts_Platforms_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Facts_Platforms_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_facts_platforms_value(inputs)
	return zh_vc_facts_platforms_value(inputs)
});
export { vc_facts_platforms_value as "vc.facts.platforms.value" }